<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
      <nav class="" id="by_header ">
        <h1 >
          <span v-on:click="ichiran" style="cursor: pointer;">
          <img v-if="header_logo" id="vy-logo" v-bind:src="header_logo" alt="ボラ活エール"/>
          <img v-else id="vy-logo" src="../../images/logo.png" alt="ボラ活エール" style="width:100%;height:auto" />

          <div style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          text-align: center;">
              <b :style="title_style1">{{ header_title1 }}</b>
              <b :style="title_style2">{{ header_title2 }}</b>
          </div>
          </span>
        </h1>
    <br>
        <p v-on:click="setting()" style="cursor:pointer">設定</p>  
        <!--
        <p v-on:click="home()" style="cursor:pointer">マイページHome</p>  
        <p v-on:click="profile()" style="cursor:pointer" >プロフィール編集</p>
        <p v-on:click="renewal()" style="cursor:pointer" v-if="GlobalData.$identities == null">パスワード変更</p>  
      -->
      </nav>
</template>

<style scoped>

</style>


<script setup>

/* eslint-disable */
/* 変数の記述 */
import { useRouter,useRoute } from 'vue-router'
import { GlobalData } from '../js/userdata.js'
let router = useRouter()
let route = useRoute()
const cityname = route.params.shakyo

const emit = defineEmits(['call'])

const props = defineProps(['param']);
  const header_logo = props.param.header_logo
  const header_title1 = props.param.header_title1
  const header_title2 = props.param.header_title2
  const title_style1 = props.param.title_style1
  const title_style2 = props.param.title_style2
const ichiran = function() {
   router.push("/"+cityname+"/Taiken" )
}
const setting = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    router.push("/"+cityname+"/Taiken/setting" )
}
</script>
